import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Article } from './article.model';

export class ArticleStateModel extends EntityStateModel<Article> {}
